import {
	GRID_CHECKBOX_SELECTION_FIELD,
	type GridColDef,
	type GridFilterModel,
	type GridLocaleText,
	type GridRowClassNameParams,
} from "@mui/x-data-grid";
import type { GridInitialState } from "@mui/x-data-grid-pro";

export const initialState: GridInitialState = {
	pinnedColumns: {
		right: ["actions"],
	},
	pagination: {
		paginationModel: { pageSize: 10, page: 0 },
	},
	sorting: {
		sortModel: [{ field: "verifiedDate", sort: "asc" }],
	},
};

export const getFilterModel = (
	isServer: boolean,
	searchText: string,
): GridFilterModel | undefined => {
	return isServer
		? undefined
		: {
				items: [],
				quickFilterValues: searchText ? [searchText] : [],
			};
};

export const getRowClassName = (params: GridRowClassNameParams) =>
	params.indexRelativeToCurrentPage % 2 === 0 ? "odd" : "even";

export const getTogglableColumns = (columns: GridColDef[]) =>
	columns
		.filter(
			(col) =>
				col.field !== GRID_CHECKBOX_SELECTION_FIELD &&
				col.field !== "mediaCode" &&
				col.field !== "actions",
		)
		.map((col) => col.field);

export const localeText: Partial<GridLocaleText> = {
	noRowsLabel: "No results",
	MuiTablePagination: {
		labelRowsPerPage: "Results per page",
	},
	footerRowSelected: (count) => `${count.toLocaleString()} media selected`,
};
